var _path, _rect, _rect2, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path4, _path5, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalDetailsMatchCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 58,
    viewBox: "0 0 69 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6C7 2.68629 9.68629 0 13 0H55C58.3137 0 61 2.68629 61 6V47C61 50.3137 58.3137 53 55 53H13C9.68629 53 7 50.3137 7 47V6Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 12,
    y: 5,
    width: 12.268,
    height: 1.80924,
    rx: 0.904618,
    fill: "#696F8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 50,
    y: 5,
    width: 5.66216,
    height: 1.80924,
    rx: 0.904618,
    fill: "#696F8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 10.8954 12.8954 10 14 10H54C55.1046 10 56 10.8954 56 12V19C56 20.1046 55.1046 21 54 21H14C12.8954 21 12 20.1046 12 19V12Z",
    fill: "#F1F3F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 17C49 15.8954 49.8954 15 51 15H54C55.1046 15 56 15.8954 56 17V21C56 22.1046 55.1046 23 54 23H51C49.8954 23 49 22.1046 49 21V17Z",
    fill: "#F1F3F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 12,
    y: 26,
    width: 17.5964,
    height: 1.25826,
    rx: 0.629129,
    fill: "#696F8E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.23,
    x: 17,
    y: 13,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#696F8E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.23,
    x: 42,
    y: 13,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#696F8E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.23,
    x: 45,
    y: 13,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#696F8E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 45.1719,
    y: 26,
    width: 10.425,
    height: 1.25826,
    rx: 0.629129,
    fill: "#696F8E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 12,
    y: 28.5156,
    width: 14.1554,
    height: 1.25826,
    rx: 0.629129,
    fill: "#696F8E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 32.4023,
    width: 69,
    height: 25.5968,
    rx: 5.41429,
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0724 51.6401H6.94489C6.55709 51.6394 6.24288 51.3252 6.24219 50.9374V50.3674C6.24705 48.7454 7.56113 47.4319 9.18316 47.4277H13.8341C15.4562 47.4319 16.7702 48.7454 16.7751 50.3674V50.9374C16.7744 51.3252 16.4602 51.6394 16.0724 51.6401Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.42955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5077 44.6873C9.93867 44.6873 8.66615 43.4165 8.66407 41.8474C8.66198 40.2784 9.93113 39.0042 11.5001 39C13.0692 38.9958 14.3451 40.2633 14.3514 41.8323C14.3537 42.5882 14.0552 43.3141 13.5218 43.8497C12.9883 44.3853 12.2636 44.6867 11.5077 44.6873Z",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 22.3594,
    y: 46.5762,
    width: 8.73388,
    height: 2.42336,
    rx: 1.21168,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 22.3594,
    y: 41.7283,
    width: 19.3409,
    height: 2.42336,
    rx: 1.21168,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9648,
    y: 43,
    width: 12.9852,
    height: 5.29084,
    rx: 1.81752,
    fill: "#6F8AF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetailsMatchCheckLarge);
export default __webpack_public_path__ + "static/media/personal_details_match_check_large.9e1ad71a7193a49d756419e0f5e4b3ab.svg";
export { ForwardRef as ReactComponent };